import React from 'react';
import {
    formatter, formatterCurrency
} from "../../../../utils/common";

const Widget = ({ textColorClass, value, label, isShowSubValue, subValue, isShowDifference, differenceValue }) => {
    textColorClass = textColorClass ? textColorClass : 'text-dark';
    return (
        <div className="col-md-6 col-xl">
            <div className={`widget-rounded-circle card-box summary-card-box`}>
                <div className="text-right">
                    <h6 className="text-truncate card-box-title">{label}</h6>
                    <h5 className={`card-box-value ${textColorClass}`}>{value}</h5>

                    {isShowSubValue ? (                    
                    <h6 className="card-box-sub-value">{subValue}</h6>
                    ) : null}

                    {isShowDifference ? (                    
                    <h6 className="card-box-sub-value text-danger">{differenceValue}</h6>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

const ChargebackTotalSummary = ({ financesSummaryState ,fillterGateway}) => {
    
    const queryParams = new URLSearchParams(window.location.search);
    
    const totalRow = financesSummaryState.chargebackDetailsTableRow;
    const totalSummary = financesSummaryState.chargebackDetailsTotalSummary;
    const currency = queryParams.get('presentment_currency');

    const widgetsData = [
        {
            value: totalRow,
            label: "Total Records",
        },
        {
            value: formatter.format(totalSummary ? totalSummary.total_amount : 0),
            label: "Total Amount",
            isShowSubValue: currency && currency !== 'GBP',
            subValue: formatterCurrency((totalSummary ? totalSummary.total_presentment_amount : 0), currency),
        },
    ];

    return (
        <div className="row">
            {widgetsData.map((widget, index) => (
                <Widget
                    key={index}
                    textColorClass={widget.textColorClass}
                    value={widget.value}
                    label={widget.label}
                    isShowSubValue={widget.isShowSubValue}
                    subValue={widget.subValue}
                    isShowDifference={widget.isShowDifference}
                    differenceValue={widget.differenceValue}
                />
            ))}
        </div>
    );
};

export default ChargebackTotalSummary;
